"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseVueMarketStrategy = void 0;
const formatConsumptionText_1 = require("../../formatConsumptionText");
const formatEmissionText_1 = require("../../formatEmissionText");
const fuelFormatter_1 = require("../../fuelFormatter");
const textResources_1 = require("../../textResources");
const utils_1 = require("../../utils");
const baseVueMarketStrategy = ({ locale, i18nlanguage }, output) => {
    const resources = new textResources_1.I18nText(locale, i18nlanguage);
    const fuels = (0, fuelFormatter_1.getFuelsFormatted)(resources, output);
    const consumptionCombinedText = (0, formatConsumptionText_1.formatConsumptionText)(resources, output.vehicleType, fuels);
    const emissionCombinedText = (0, formatEmissionText_1.formatEmissionText)(resources, output.vehicleType, fuels);
    const formattedFuels = (0, utils_1.formatFuels)(resources, fuels);
    output.formattedConsumption = consumptionCombinedText;
    output.formattedEmission = emissionCombinedText;
    output.formattedFuels = formattedFuels;
    output.fuels = fuels;
    return output;
};
exports.baseVueMarketStrategy = baseVueMarketStrategy;
